"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageModal = exports.Modal = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _modal = _interopRequireDefault(require("antd/es/modal"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./style.sass");
var _Button = require("../Button");
var _Icons = require("../Icons");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var Modal = function Modal(props) {
  var _cn;
  var sberClassName = 'sber-modal';
  var sberWrapClassName = (0, _classnames.default)("".concat(sberClassName, "-wrap"), props.className, (_cn = {}, _defineProperty(_cn, "".concat(sberClassName, "-wrap--middle"), props.size === 'middle'), _defineProperty(_cn, "".concat(sberClassName, "-wrap--small"), props.size === 'small'), _defineProperty(_cn, "".concat(sberClassName, "-wrap--large"), props.size === 'large'), _cn));
  var _props$className = props.className,
    className = _props$className === void 0 ? sberClassName : _props$className,
    _props$wrapClassName = props.wrapClassName,
    wrapClassName = _props$wrapClassName === void 0 ? sberWrapClassName : _props$wrapClassName,
    _props$closable = props.closable,
    closable = _props$closable === void 0 ? true : _props$closable,
    _props$destroyOnClose = props.destroyOnClose,
    destroyOnClose = _props$destroyOnClose === void 0 ? true : _props$destroyOnClose,
    _props$footer = props.footer,
    footer = _props$footer === void 0 ? false : _props$footer,
    _props$closeIcon = props.closeIcon,
    closeIcon = _props$closeIcon === void 0 ? /*#__PURE__*/_react.default.createElement(_Icons.CloseIcon, {
      color: "#adadad",
      size: 24
    }) : _props$closeIcon,
    rest = _objectWithoutProperties(props, ["className", "wrapClassName", "closable", "destroyOnClose", "footer", "closeIcon"]);
  return /*#__PURE__*/_react.default.createElement(_modal.default, _extends({}, rest, {
    className: className,
    wrapClassName: wrapClassName,
    closeIcon: closeIcon,
    closable: closable,
    destroyOnClose: destroyOnClose,
    footer: footer
  }), props.children);
};
exports.Modal = Modal;
Modal.propTypes = {
  type: _propTypes.default.oneOf(['attention', 'alert', 'success']),
  text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  buttonText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  buttonClickHandle: _propTypes.default.func,
  size: _propTypes.default.oneOf(['small', 'middle', 'large'])
};
var MessageModal = function MessageModal(_ref) {
  var _cn2;
  var className = _ref.className,
    type = _ref.type,
    title = _ref.title,
    text = _ref.text,
    buttonText = _ref.buttonText,
    buttonClickHandle = _ref.buttonClickHandle,
    onCancel = _ref.onCancel,
    props = _objectWithoutProperties(_ref, ["className", "type", "title", "text", "buttonText", "buttonClickHandle", "onCancel"]);
  var sberClassName = 'sber-modal';
  var mainClassName = (0, _classnames.default)(sberClassName, (_cn2 = {}, _defineProperty(_cn2, "".concat(sberClassName, "--attention"), type === 'attention'), _defineProperty(_cn2, "".concat(sberClassName, "--alert"), type === 'alert'), _defineProperty(_cn2, "".concat(sberClassName, "--success"), type === 'success'), _cn2));
  return /*#__PURE__*/_react.default.createElement(Modal, _extends({}, props, {
    className: mainClassName,
    onCancel: onCancel,
    destroyOnClose: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sber-text-center"
  }, type === 'attention' && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(sberClassName, "__icon")
  }, /*#__PURE__*/_react.default.createElement(_Icons.AttentionIcon, null)), type === 'success' && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(sberClassName, "__icon")
  }, /*#__PURE__*/_react.default.createElement(_Icons.SuccessIcon, null)), title && /*#__PURE__*/_react.default.createElement("h4", {
    className: "".concat(sberClassName, "__title")
  }, title), text && /*#__PURE__*/_react.default.createElement("p", {
    className: "".concat(sberClassName, "__text")
  }, text), /*#__PURE__*/_react.default.createElement("div", {
    className: "sber-modal__btn"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    onClick: buttonClickHandle
  }, buttonText))));
};
exports.MessageModal = MessageModal;
MessageModal.propTypes = {
  type: _propTypes.default.oneOf(['attention', 'alert', 'success']),
  text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  buttonText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  buttonClickHandle: _propTypes.default.func,
  size: _propTypes.default.oneOf(['small', 'middle', 'large'])
};